/*
 * サブシステム名：受注
 * 機能名：受付一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'

// 個別メッセージ用
import Swal from 'sweetalert2'

const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')

export default {
  name: 'ankenList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {},
    searchText: '',
    modeKengen: 0,
    page: 1,
    isLoading: false,

    // ヘッダー定義
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,

    // PrintLoading
    isExcelDownloader: false,
    isBatchCommandloader: false,
    isCheckSheetDownloader: false,
    // ボタン制御
    isCheckSheetBatchDownload: true,

    // ページネーション用
    vItemsPerPage: 100,
    vPage: 1,

    // 一括操作用定義
    batchCommand: null,
    batchCommandList: [
      { value: null, text: '未選択' },
      { value: 1, text: 'ステータス更新' },
      { value: 2, text: 'チェックリストDL' },
      { value: 3, text: '領収書DL' }
    ],
    isShowUpdateStatusDialog: false,
    batchStatus: {
      sagyoKanryoFlg: false,
      uriageKakuteiFlg: false,
      notYayoiRenkeiFlg: false
    }
  }),
  components: {
    DdCustomButton,
    DdCodeTextBox,
    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox,
    DdSelectItemsPerPage
  },
  watch: {
    'conditions.zenjitsuSagyoKanryoFlg': function () {
      if (this.conditions.zenjitsuSagyoKanryoFlg) {
        var date = new Date()
        const zenjitsu = filter.dateFormatter(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1))
        this.conditions.sagyoStartYmdString = zenjitsu
        this.conditions.sagyoEndYmdString = zenjitsu
      }
    },
    'conditions.iraisakiId': function () {
      if (!this.isLoading) this.conditions.sagyoTantoshaId = null
    }
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      loginUserId: 'users/userId',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 受注基本ID定義
        elem.trJuchuKihonId = elem.id

        // 表示用作業依頼日作成
        var sagyoYoteiYmdFromDisp = elem.sagyoYoteiYmdFrom ? (filter.dateFormatter(elem.sagyoYoteiYmdFrom)).slice(-5) : ''
        var sagyoYoteiYmdToDisp = elem.sagyoYoteiYmdTo ? '～' + (filter.dateFormatter(elem.sagyoYoteiYmdTo)).slice(-5) : ''
        var sagyoYoteiYmdDisp = sagyoYoteiYmdFromDisp + sagyoYoteiYmdToDisp

        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem2.iraiDaisuDisp = [undefined, null].includes(elem.iraiDaisu) ? '' : filter.numericFormatter(elem.iraiDaisu)
        elem2.sagyoYoteiYmdFromDisp = elem.sagyoYoteiYmdFrom ? (filter.dateFormatter(elem.sagyoYoteiYmdFrom)) : ''
        elem2.sagyoYoteiYmdToDisp = elem.sagyoYoteiYmdTo ? (filter.dateFormatter(elem.sagyoYoteiYmdTo)) : ''
        elem2.sagyoYoteiYmdDisp = sagyoYoteiYmdDisp
        elem2.seikyuSagyoKingakuKeiDisp = [undefined, null].includes(elem.seikyuSagyoKingakuKei) ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei)
        elem2.seikyuBuzaiKingakuKeiDisp = [undefined, null].includes(elem.seikyuBuzaiKingakuKei) ? '' : filter.numericFormatter(elem.seikyuBuzaiKingakuKei)
        elem2.seikyuKingakuKeiDisp = filter.numericFormatter((elem.seikyuSagyoKingakuKei ?? 0) + (elem.seikyuBuzaiKingakuKei ?? 0))
        elem2.shiharaiKingakuKeiDisp = [undefined, null].includes(elem.shiharaiKingakuKei) ? '' : filter.numericFormatter(elem.shiharaiKingakuKei)

        // 状況表示
        elem2.sagyoKanryoStatus = [undefined, null, ''].includes(elem2.sagyoCompleteCnt) ? '' : elem2.sagyoCompleteCnt + ' / ' + elem2.iraiDaisu
        elem2.uriageKakuteiStatus = [undefined, null, ''].includes(elem2.uriageCompleteCnt) ? '' : elem2.uriageCompleteCnt + ' / ' + elem2.iraiDaisu

        var seikyuStatus = '未請求'
        if (elem.yayoiRenkeiCompleteFlg) seikyuStatus = '弥生連携済み'
        if (elem.notYayoiRenkeiCompleteFlg) seikyuStatus = '弥生連携不要'
        if (elem.seikyuTomeFlg) seikyuStatus = '請求止め'
        if (elem.matomeSeikyuFlg) seikyuStatus = 'まとめ請求'
        elem2.seikyuStatus = seikyuStatus

        elem2.receiptStatus = [undefined, null, 0].includes(elem2.receiptCount) ? '無' : '有'

        return elem2
      })
    },
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 発注先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return (elem.hacchusakiFlg === true || elem.torihikisakiBunruiKbn1 === '02') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 受付担当者
    filteredUketsukeTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 作業担当者
    filteredSagyoTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const sagyoIraisaki = this.filteredHacchusakiList.find(elem2 => elem2.id === this.conditions.iraisakiId)
        if (!sagyoIraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoIraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 商品名
    filteredShohinList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hinshuSbt === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    // 作業区分
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isBatchExecButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.batchCommand !== null && this.selected.length > 0) {
        return false
      }
      return true
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'msthinmei', 'msyskubun', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGRCOD0010.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'data-table-select', width: '42px' },
              { text: '編集', value: 'actions', sortable: false, width: '42px', align: 'center' },
              { text: '', value: 'jissekiMikakuninFlg', class: 'px-0', width: '42px', align: 'center' },
              { text: '作業ステータス', value: 'chumonStatus', width: '125px' },
              { text: '請求ステータス', value: 'seikyuStatus', width: '125px' },
              { text: '作業予定日', value: 'sagyoYoteiYmdFromDisp', width: '105px' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '取付先', value: 'toritsukesaki' },
              { text: '営業所', value: 'toritsukesakiEigyosho' },
              { text: '作業者名', value: 'sagyoIraisakiInfo' },
              // { text: '得意先コード', value: 'tokuisakiCd' },
              // { text: '作業予定日TO', value: 'sagyoYoteiYmdToDisp', align: 'center' },
              // { text: 'ジャンル', value: 'genreNm' },
              // { text: '電話番号', value: 'denpyoBiko3' },
              // { text: '取付先 郵便番号', value: 'toritsukesakiYubinNo' },
              // { text: '取付先 住所1', value: 'toritsukesakiJusho1' },
              // { text: '取付先 住所2', value: 'toritsukesakiJusho2' },
              // { text: '電話番号2', value: 'toritsukesakiJusho3' },
              // { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
              // { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
              // { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
              // { text: '作業場所 住所3', value: 'sagyobashoJusho3' },
              // ↓一覧用
              // { text: '請求ランク', value: 'seikyuRankNm' },
              // { text: '作業内容確定', value: 'sagyoNaiyoKakuteiFlgString', align: 'center' },
              // { text: '作業内容確定担当者', value: 'sagyoNaiyoKakuteiTantoshaNm' },
              // { text: '作業内容確定日', value: 'sagyoNaiyoKakuteiYmdDisp', align: 'center' },
              // { text: '請求確定', value: 'unchinKakuteiFlgString', align: 'center' },
              // { text: '請求確定担当者', value: 'unchinCheckTantoshaNm' },
              // { text: '請求確定日', value: 'unchinCheckYmdDisp', align: 'center' },
              // { text: '請求止め', value: 'seikyuTomeFlgString', align: 'center' },
              // { text: '連携データ作成', value: 'seikyuZumiFlgString', align: 'center' },
              // { text: '連携データ作成日', value: 'seikyuYoteiYmdDisp', align: 'center' },
              // { text: '担当者', value: 'denpyoBiko2' },
              // { text: '取付先備考', value: 'hanyoBiko' },
              // { text: '受付備考', value: 'biko' },
              // { text: '見積差分備考', value: 'mitsumoriSabunBiko' },
              // { text: '宛名', value: 'denpyoBiko4' },
              // { text: '件名', value: 'kenmeiNm' },
              // { text: '納入場所', value: 'denpyoBiko5' },
              // { text: '有効期限', value: 'yukokigenNm' },
              // { text: '見積備考', value: 'mitsumoriBiko' },
              // { text: '会社コード', value: 'denpyoBiko6' },
              // { text: 'IPアドレス', value: 'denpyoBiko7' },
              // { text: 'ポート番号', value: 'denpyoBiko8' },
              // { text: '見積作業金額計', value: 'mitsumoriSagyoKingakuKeiDisp', align: 'end' },
              // { text: '見積部材金額計', value: 'mitsumoriBuzaiKingakuKeiDisp', align: 'end' },
              // { text: '見積金額計', value: 'mitsumoriKingakuKeiDisp', align: 'end' },
              { text: '作業', value: 'sagyoKbnNm' },
              { text: '商品', value: 'shohinNm' },
              { text: '作業完了状況', value: 'sagyoKanryoStatus', align: 'center', sortable: false },
              { text: '依頼台数', value: 'iraiDaisu' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '受付担当者', value: 'uketsukeTantoshaNm' },
              { text: '受付日', value: 'juchuYmdDisp', align: 'center' },
              { text: '請求作業金額計', value: 'seikyuSagyoKingakuKeiDisp', align: 'end' },
              { text: '請求部材金額計', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end' },
              { text: '請求金額計', value: 'seikyuKingakuKeiDisp', align: 'end' },
              { text: '支払金額計', value: 'shiharaiKingakuKeiDisp', align: 'end' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' },
              { text: '売上確定状況', value: 'uriageKakuteiStatus', align: 'center', sortable: false },
              { text: '領収書有無', value: 'receiptStatus', align: 'center' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              uketsukeTantoshaId: self.loginUserId,
              sagyoYoteiStartYmdString: null,
              sagyoYoteiEndYmdString: null,
              sagyoStartYmdString: null,
              sagyoEndYmdString: null,
              zenjitsuSagyoKanryoFlg: null,
              tokuisakiId: null,
              toritsukesaki: null,
              denpyoBiko1: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              iraisakiId: null,
              sagyoTantoshaId: null,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true,
              includeCancelFlg: false,
              excludeSeikyuTomeFlg: false,
              excludeYayoiRenkeiFlg: false
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGRCOD0010.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          // DB上は"true"の文字列で設定される。Booleanにするために文字列"true"と比較させる。
          self.conditions.includeCancelFlg = ![undefined, null].includes(c.includeCancelFlg) ? c.includeCancelFlg === 'true' : false
          self.conditions.excludeSeikyuTomeFlg = ![undefined, null].includes(c.excludeSeikyuTomeFlg) ? c.excludeSeikyuTomeFlg === 'true' : false
          self.conditions.excludeYayoiRenkeiFlg = ![undefined, null].includes(c.excludeYayoiRenkeiFlg) ? c.excludeYayoiRenkeiFlg === 'true' : false

          console.log('TGRCOD0010.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGRCOD0010.researchPromise', c)
          // modals.showToast('検索中です。しばらくお待ちください。', 1500, 550, 'top-end', 'info')
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.$nextTick(() => { self.isLoading = false })
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGRCOD0010.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
              self.$nextTick(() => { self.isLoading = false })
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.vPage = 1
      this.isCheckSheetBatchDownload = true

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.isLoading = true

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgrcod001170/search', self.conditions)
              .then((data) => {
                if (![undefined, null, ''].includes(self.conditions.toritsukesaki)) {
                  self.isCheckSheetBatchDownload = false
                }
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.isLoading = false
            })
        },
        getSavedInputMethod: function () {
          return {
            includeCancelFlg: self.conditions.includeCancelFlg,
            excludeSeikyuTomeFlg: self.conditions.excludeSeikyuTomeFlg,
            excludeYayoiRenkeiFlg: self.conditions.excludeYayoiRenkeiFlg
          }
        }
      }
      this.search(opt)
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
      if (msg !== undefined) {
        this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 依頼日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.iraiStartYmdString, this.conditions.iraiEndYmdString)
      if (msg !== undefined) {
        this.$refs.iraiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.iraiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業予定日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoStartYmdString, this.conditions.sagyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            self.conditions = {
              uketsukeTantoshaId: self.loginUserId,
              sagyoYoteiStartYmdString: null,
              sagyoYoteiEndYmdString: null,
              sagyoStartYmdString: null,
              sagyoEndYmdString: null,
              zenjitsuSagyoKanryoFlg: null,
              tokuisakiId: null,
              toritsukesaki: null,
              denpyoBiko1: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              iraisakiId: null,
              sagyoTantoshaId: null,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true,
              includeCancelFlg: false,
              excludeSeikyuTomeFlg: false,
              excludeYayoiRenkeiFlg: false
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.vPage = 1
            self.isCheckSheetBatchDownload = true
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: f.item.trJuchuMeisaiId, backactionno: 0 })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: item.trJuchuMeisaiId, backactionno: 0 })
    },
    onExcelDownloadButtonClick: function (e) {
      var juchuMeisaiIdList = []

      if (this.selected.length > 0) {
        this.showConfirmExcelOutputPattern().then((result) => {
          if (result.isConfirmed) {
            // ダウンロード対象作成
            this.selected.filter((x) => {
              return ![undefined, null, '', 0].includes(x.iraiDaisu)
            }).forEach((x) => {
              juchuMeisaiIdList.push(x.trJuchuMeisaiId)
            })
          } else if (result.isDenied) {
            if (juchuMeisaiIdList.length === 0) {
              this.filteredRows.forEach((x) => {
                juchuMeisaiIdList.push(x.trJuchuMeisaiId)
              })
            }
          } else {
            // 何もしない
            return false
          }
          this.outputExcel(juchuMeisaiIdList)
        })
      } else {
        if (juchuMeisaiIdList.length === 0) {
          this.filteredRows.forEach((x) => {
            juchuMeisaiIdList.push(x.trJuchuMeisaiId)
          })
        }
        this.outputExcel(juchuMeisaiIdList)
      }
    },
    outputExcel: function (juchuMeisaiIdList) {
      const updInfo = {
        trJuchuMeisaiId: juchuMeisaiIdList
      }

      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/Tgrcod0011/ExcelOutput', updInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('download')
          this.isExcelDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '案件一覧_' + ts + '.xlsx'
          elem.click()
        })
    },
    onCheckSheetDownloadButtonClick: function (e) {
      console.log('onCheckSheetDownloadButtonClick')
      const self = this
      // ZIPファイル名生成
      const toritsukesaki = this.conditions.toritsukesaki

      this.isCheckSheetDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/Tgrcod0011/CheckSheetBatchDownLoad', self.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const zipFileNmae = 'チェックシート' + '_' + toritsukesaki + '_' + ts + '.zip'
          const blob = new Blob([data], { type: 'application/zip' })
          const elem = document.getElementById('batchDownload')
          self.isCheckSheetDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = zipFileNmae
          elem.click()
        })
    },

    /**
     * ステータス一括更新
     */
    onCheckMatomeSeikyuFlg: function (e) {
      if (this.batchStatus.matomeSeikyuFlg) {
        this.batchStatus.uriageKakuteiFlg = true
        this.batchStatus.notYayoiRenkeiFlg = true
      }
    },
    onBatchCommandButtonClick: function (e) {
      if (this.batchCommand === null) return
      if (this.batchCommand === 1) {
        this.isShowUpdateStatusDialog = true
      } else if (this.batchCommand === 2) {
        this.isBatchCommandloader = true
        this.execCheckSheetSpecifiedDownLoad()
      } else if (this.batchCommand === 3) {
        this.isBatchCommandloader = true
        this.execReceiptSpecifiedDownLoad()
      }
    },
    execBatchUpdateStatus: function () {
      // modals.showToast('ステータス更新 > ' + this.selected.length, 1500, 550, 'top-end', 'info')
      const self = this

      this.Effects.loadStart()

      // 更新情報作成
      var juchuMeisaiIdList = []
      this.selected.filter((x) => {
        return ![undefined, null, '', 0].includes(x.iraiDaisu)
      }).forEach((x) => {
        juchuMeisaiIdList.push(x.trJuchuMeisaiId)
      })
      const updInfo = {
        sagyoKanryoFlg: this.batchStatus.sagyoKanryoFlg,
        uriageKakuteiFlg: this.batchStatus.uriageKakuteiFlg,
        notYayoiRenkeiFlg: this.batchStatus.notYayoiRenkeiFlg,
        matomeSeikyuFlg: this.batchStatus.matomeSeikyuFlg,
        trJuchuMeisaiId: juchuMeisaiIdList
      }

      function batchUpdatePromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient.post('/api/v1/Tgrcod0021/BatchStatusUpdate', updInfo).then((data) => {
            resolve(data)
          })
        })
      }
      batchUpdatePromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('対象のステータスを更新しました。')
        self.isShowUpdateStatusDialog = false
        // 再検索
        this.onSearchButtonClick()
      })
    },
    execCheckSheetSpecifiedDownLoad: function () {
      const self = this

      this.Effects.loadStart()

      // ダウンロード対象作成
      var juchuMeisaiIdList = []
      this.selected.filter((x) => {
        return ![undefined, null, '', 0].includes(x.iraiDaisu)
      }).forEach((x) => {
        juchuMeisaiIdList.push(x.trJuchuMeisaiId)
      })
      const updInfo = {
        trJuchuMeisaiId: juchuMeisaiIdList
      }

      if (updInfo.length === 0) return

      function specifiedDownloadPromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgrcod0021/CheckSheetSpecifiedDownload', updInfo)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = 'チェックシート' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isBatchCommandloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された案件のチェックシートをダウンロードしました')
      })
    },
    execReceiptSpecifiedDownLoad: function () {
      const self = this

      this.Effects.loadStart()

      // ダウンロード対象作成
      var juchuMeisaiIdList = []
      this.selected.filter((x) => {
        return x.receiptCount > 0
      }).forEach((x) => {
        juchuMeisaiIdList.push(x.trJuchuMeisaiId)
      })
      const updInfo = {
        trJuchuMeisaiId: juchuMeisaiIdList
      }

      if (updInfo.length === 0) return

      function specifiedDownloadPromise (updInfo) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgrcod0021/ReceiptSpecifiedDownload', updInfo)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = '領収書' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isBatchCommandloader = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(updInfo).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された案件のチェックシートをダウンロードしました')
      })
    },

    /*
    onEditButtonClick: function (e) {
      console.log(e)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: this.selected[0].trJuchuMeisaiId, backactionno: 0 })
    },
    */
    onCreateButtonClick: function (e) {
      console.log(e)
      this.saveConditionToCache()
      this.Effects.loadStart()
      this.transition(0, { id: 0, backactionno: 0 })
    },
    saveConditionToCache: function () {
      const cache = {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
      this.saveToChache(cache)
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    },
    // EXCEL出力メッセージ
    showConfirmExcelOutputPattern: function (args) {
      return new Promise((resolve) => {
        Swal.fire({
          showDenyButton: true,
          showCancelButton: true,
          title: '',
          html: '行がチェックされています。<br>EXCEL出力対象を指定して下さい。',
          icon: 'question',
          confirmButtonColor: '#FFFFFF',
          confirmButtonText: 'チェックした行だけ出力',
          denyButtonColor: '#2F75B5',
          denyButtonText: '全て出力',
          cancelButtonColor: '#6E7D88',
          cancelButtonText: 'キャンセル',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 sa-s-button-cancel right-gap',
            confirmButton: 'order-2 excel-output-confirm',
            denyButton: 'order-3 sa-s-button-deny'
          }
        }).then((result) => {
          resolve(result)
        })
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      if (this.filteredRows.length === 0) return
      this.vItemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      if (this.filteredRows.length === 0) return
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    }
  }
}
